import type { FC } from 'react';
import { Input, type InputProps } from './Input';
import { useFormatNumber } from './react';

export type PriceInputProps = Omit<
  InputProps,
  'type' | 'step' | 'min' | 'max'
> & {
  precision?: number;
  max?: string;
};

export const PriceInput: FC<PriceInputProps> = ({
  onChange,
  value,
  precision,
  max,
  ...rest
}) => {
  const formatter = useFormatNumber();
  return (
    <Input
      value={formatter.format(value ?? '')}
      min={0}
      max={max ? +max : undefined}
      onChange={(newValue) => {
        if (!newValue) {
          onChange?.('');
          return;
        }
        let deformatted = formatter.deFormat(newValue);
        const [base, decimal] = deformatted.split('.');
        precision = precision ?? 0;
        if (precision === 0) {
          deformatted = base;
        } else if (decimal && decimal.length > precision) {
          deformatted = `${base}.${decimal.slice(0, precision ?? 0)}`;
        }
        if (max && +deformatted > +max) {
          deformatted = formatter.deFormat(max);
        }
        onChange?.(deformatted);
      }}
      {...rest}
    />
  );
};
